/** @format */

import React, { useState } from "react"
import { Button, InputAdornment, TextField } from "@material-ui/core"
import { useMediaQuery } from "react-responsive"
import ReactCodeInput from "react-code-input"
import {
  loginWithMobile,
  VerifyLogin,
} from "../../Homepage/pages/widgets/components/cruds"
import { useDispatch, useSelector } from "react-redux"
import { actions as authActions } from "../../Auth/_redux/authRedux"
import { actions } from "../redux"
import { useFormik } from "formik"
import * as Yup from "yup"
import { contractLogin, getOwnerToken } from "../contractLoginAction"

import config from "../../../../config/config"
import axios from "axios"
// import getOwnerToken from "../contractLoginAction"

const VERIFY_LOGIN = config.baseUrl + "owner/verifyLogin/"

export default (props) => {
  const [phoneNumber, setPhoneNumber] = useState(null)
  const [firstName, setFirstName] = useState(null)
  const [lastName, setLastName] = useState(null)
  const [nationalCode, setNationalCode] = useState(null)
  const [pinCode, setPinCode] = useState(null)
  const [isPhoneEntered, setIsPhoneEntered] = useState(false)
  const [errMessage, setErrMessage] = useState(null)

  const phoneRegex = new RegExp("^(\\+98|0)?9\\d{9}$")
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` })
  const ownerState = useSelector((state) => state.owner)
  const { user } = useSelector((state) => state.auth)
  const dispatch = useDispatch()

  const verifyLoginSuccessPromiseHandler = (res) => {
    dispatch(
      actions.getAllOwnerInfo({
        ...ownerState.ownerInfo,
        firstName,
        lastName,
        nationalCode,
        phone: phoneNumber,
      })
    )
    setErrMessage(null)
    setIsPhoneEntered(false)
    setPhoneNumber(null)
    setPinCode(null)
    props.stepOBJ.setCurrentStep("2")
    const date = new Date()
    date.setDate(date.getDate() + 1)
    const dateOBJ = { date }
    localStorage.setItem("tokenExpireTime", JSON.stringify(dateOBJ))
    dispatch(authActions.login(res.data.data))
    window.localStorage.setItem(
      "userInformation",
      JSON.stringify(res.data.data)
    )
  }

  const verifyLoginFailedPromiseHandler = (err) => {
    if (err.response.data.message === "code is not valid!") {
      setErrMessage("کد نامعتبر است")
    } else if (err.response.data.message === "User not found!") {
      setErrMessage("کد وارد شده کامل نیست")
    } else {
      setErrMessage("مشکلی در ارتباط با سرور بوجود آمد")
    }
  }

  const loginSuccessPromiseHandler = () => {
    setIsPhoneEntered(true)
    setErrMessage(null)
  }

  const loginFailedPromiseHandler = () => {
    setErrMessage("مشکلی در ارتباط با سرور بوجود آمد")
  }

  const propsz = {
    className: "class-Input ",
    inputStyle: {
      textAlign: "center",
      fontFamily: "sans",
      borderRadius: "6px",
      border: "1px solid lightgrey",
      boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px",
      margin: "4px",
      paddingLeft: "8px",
      paddingRight: "0px",
      width: "10%",
      height: "42px",
      fontSize: "32px",
      boxSizing: "border-box",
      color: "black",
      backgroundColor: "white",
      direction: "ltr",
      flexGrow: 1,
    },
    touch: {
      border: "1px solid green",
    },
    inputStyleInvalid: {
      fontFamily: "monospace",
      margin: "4px",
      MozAppearance: "textfield",
      width: "15px",
      borderRadius: "3px",
      fontSize: "14px",
      height: "26px",
      paddingLeft: "7px",
      backgroundColor: "red",
      color: "red",
      border: "1px solid red",
    },
  }

  const TextFieldStyle = {
    width: "100%",
    // borderRadius: "13px",
    // border: "1px solid #d9d9d9",
    // width: isMobile ? "22rem" : "35rem",
    marginTop: "3.5rem",
  }

  // Validation schema
  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, "نام حدقل ۲ کاراکتر باشد.")
      .required("لطفا نام خود را وارد کنید."),
    lastName: Yup.string()
      .min(2, "نام خانوادگی حدقل 2 کاراکتر باشد.")
      .required("لطفا نام خانوادگی خود را وارد کنید."),
    nationalCode: Yup.string()
      .min(10, "کدملی ۱۰ کاراکتر باشد.")
      .required("لطفا کدملی خود را وارد کنید."),
    phoneNumber: Yup.string()
      .min(10, "شماره موبایل ۱۰ رقم باشد.")
      .max(11, "شماره موبایل بیشتر از ۱۱ رقم نباشد.")
      .required("لطفا شماره موبایل خود را وارد کنید."),
  })

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      nationalCode: "",
      phoneNumber: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (phoneRegex.test(values.phoneNumber)) {
        setFirstName(values.firstName)
        setLastName(values.lastName)
        setNationalCode(values.nationalCode)
        setPhoneNumber(values.phoneNumber)
        // props.stepOBJ.setCurrentStep("2");
        const data = {
          firstName: values.firstName,
          lastName: values.lastName,
          nationalCode: values.nationalCode,
          // phoneNumber: values.phoneNumber,
          phone: `${+values.phoneNumber[0] === 0
              ? values.phoneNumber
              : `0${values.phoneNumber}`
            }`,
          roles: ["Owner"],
        }
        console.log("data", data)
        const newData = {
          phone: data.phone,
          roles: ["Owner"],
        }
        contractLogin(newData)
        setIsPhoneEntered(true)
        setErrMessage(null)
      }
    },
  })

  return (
    <div class="row">
      <div style={{ minHeight: "46rem", width: "100%" }}>
        <div
          id="jobHd"
          className="w-100"
          style={{
            height: "7.5rem",
            backgroundColor: "#6dd06d",
            position: "relative",
            boxShadow: "0px 0px 10px #6dd06d",
          }}
        >
          <h2
            className="text-white"
            style={{
              height: "100%",
              display: "flex",
              marginRight: "15px",
              // justifyContent: "center",
              alignItems: "center",
            }}
          >
            سامانه ثبت مالکین
          </h2>
        </div>
        <div
          style={{
            // position: "absolute",
            borderRadius: "13px",
            height: "fit-content",
            width: "90%",
            // left: "0px",
            // right: "0px",
            boxShadow: "0px 0px 10px lightgray",
            marginTop: "20px",
          }}
          className="sabtMalek bg-white mx-auto container-fluid d-flex flex-column align-items-center p-3"
        >
          <h1
            style={{
              borderBottom: "3px solid #6dd06d",
              height: "fit-content",
              padding: "10px",
            }}
          >
            <b>{!isPhoneEntered ? "ثبت نام" : "تایید کد"}</b>
          </h1>
          {!isPhoneEntered ? (
            <>
              <form style={{ width: "70%" }} onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-md-6 col-lg-6">
                    <TextField
                      label="نام"
                      id="firstName"
                      name="firstName"
                      style={TextFieldStyle}
                      // onChange={handleChange}
                      // value={firstName}
                      InputProps={{
                        style: { direction: "rtl" },
                      }}
                      variant="outlined"
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.firstName &&
                        Boolean(formik.errors.firstName)
                      }
                      helperText={
                        formik.touched.firstName && formik.errors.firstName
                      }
                    />
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <TextField
                      id="lastName"
                      style={TextFieldStyle}
                      // onChange={(e) => {
                      //   setLastName(e.target.value);
                      // }}
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.lastName &&
                        Boolean(formik.errors.lastName)
                      }
                      helperText={
                        formik.touched.lastName && formik.errors.lastName
                      }
                      InputProps={{
                        style: { direction: "rtl" },
                      }}
                      variant="outlined"
                      placeholder="نام خانوادگی خود را وارد کنید"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-lg-6">
                    <TextField
                      id="nationalCode"
                      style={TextFieldStyle}
                      // onChange={(e) => {
                      //   setNationalCode(e.target.value);
                      // }}
                      value={formik.values.nationalCode}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.nationalCode &&
                        Boolean(formik.errors.nationalCode)
                      }
                      helperText={
                        formik.touched.nationalCode &&
                        formik.errors.nationalCode
                      }
                      InputProps={{
                        style: { direction: "rtl" },
                      }}
                      variant="outlined"
                      placeholder="کد ملی خود را وارد کنید"
                    />
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <TextField
                      id="phoneNumber"
                      style={TextFieldStyle}
                      // onChange={(e) => {
                      //   setPhoneNumber(e.target.value);
                      // }}
                      value={formik.values.phoneNumber}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.phoneNumber &&
                        Boolean(formik.errors.phoneNumber)
                      }
                      helperText={
                        formik.touched.phoneNumber && formik.errors.phoneNumber
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <h5
                              className="ml-auto d-flex align-items-center justify-content-center"
                              style={{
                                marginTop: "4.5rem",
                                borderRight: "2px solid #6dd06d",
                                paddingRight: "10px",
                                height: "3rem",
                                paddingLeft: "5px",
                              }}
                            >
                              <span style={{ fontFamily: "sans" }}> 98+</span>
                            </h5>
                          </InputAdornment>
                        ),
                        style: { direction: "ltr" },
                      }}
                      variant="outlined"
                      placeholder="شماره موبایل خود را وارد کنید"
                    />
                  </div>
                </div>
                {errMessage && (
                  <h6 style={{ marginTop: "1rem", color: "red" }}>
                    {errMessage}
                  </h6>
                )}
                <h6 style={{ lineHeight: "25px", marginBlock: "3.2rem" }}>
                  با پر کردن فرم ثبت نام{" "}
                  <a
                    style={{ textDecoration: "underline" }}
                    href="https://ebus.ir/Conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    قوانین و مقررات
                  </a>{" "}
                  استفاده از ایباس را مطالعه کرده و با تمامی آن موافقم.
                </h6>
                <div className="row">
                  <div className="col-md-12">
                    <Button
                      type="submit"
                      style={{
                        // width: isMobile ? "22rem" : "35rem",
                        width: "100%",
                        borderRadius: "13px",
                        backgroundColor: "#6dd06d",
                        height: "4rem",
                        marginBottom: "6rem",
                      }}
                      onClick={ async () => {
                        if (phoneRegex.test(phoneNumber)) {
                          // props.stepOBJ.setCurrentStep("2");
                          const data = {
                            firstName,
                            lastName,
                            nationalCode,
                            phone: `${+phoneNumber[0] === 0
                                ? phoneNumber
                                : `0${phoneNumber}`
                              }`,
                            roles: ["Owner"],
                          }
                          console.log("data", data)
                          const newData = {
                            phone: data.phone,
                            roles: ["Owner"],
                          }

                          contractLogin(newData)
                          setIsPhoneEntered(true)
                          setErrMessage(null)
                        }
                      }}
                    >
                      <h6 className="my-auto text-white">ثبت نام</h6>
                    </Button>
                  </div>
                </div>
              </form>
            </>
          ) : (
            <>
              <ReactCodeInput
                {...propsz}
                type="number"
                fields={6}
                onChange={(e) => {
                  setPinCode(e)
                }}
                style={{
                  width: isMobile ? "22rem" : "35rem",
                  marginTop: "3.5rem",
                }}
              />
              {errMessage && (
                <h6 style={{ marginTop: "1rem", color: "red" }}>
                  {errMessage}
                </h6>
              )}
              <Button
                style={{
                  width: isMobile ? "22rem" : "35rem",
                  borderRadius: "13px",
                  backgroundColor: "#6dd06d",
                  height: "4rem",
                  marginBlock: "6rem 3rem",
                }}
                onClick={async () => {
                  const data = {
                    phone: `${+phoneNumber[0] === 0 ? phoneNumber : `0${phoneNumber}`
                      }`,
                    code: pinCode,
                  }
                  axios
                    .post(VERIFY_LOGIN, data)
                    .then((res) => {
                      dispatch(getOwnerToken(res.data.data.token))
                      // console.log("verify code res", res.data.data.token)
                      props.stepOBJ.setTest(false)
                    })
                    .catch(
                      (err) => alert("کد وارد شده صحیح نمی باشد")
                      // props.stepOBJ.setTest(false)
                    )
                }}
              >
                <h6 className="my-auto text-white">تایید</h6>
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
